import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Spin } from 'antd';

import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';
import { convertirTextAMomentUTC } from '../../commons/gestioDates';

class ImatgeAutorrecarregable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            estaCarregantImatge: true,
            seguentActualitzacio: null
        };
    }

    // Càlcul d'hora/minut com a objecte moment
    obtenirMomentAPartirDHoraIMinut(data, horaMinut) {
        const hora = horaMinut.substring(0, 2);
        const minut = horaMinut.substring(3, 5);
        return data.clone().hour(hora).minute(minut).second(0).millisecond(0);
    }

    // Càlcul d'hora/minut com a objecte de tipus duració
    obtenirDuracioAPartirDHoraIMinut(horaMinut) {
        return moment.duration(horaMinut + ':00');
    }

    /**
     * Obté la llista de les possibles actualitzacions. Per exemple, si rep:
     *  - inici: 00:30 (hora a la que es comença)
     *  - periode: 03:00 (execució cada tres hores)
     *  - marge: 00:15 (marge que es dóna per que la imatge estigui disponible)
     * I estem a data 24/11/2017 a les 12:34 generarà un array amb els següents objectes moments.
     *  - moment("2017-11-24T00:45:00.000")
     *  - moment("2017-11-24T03:45:00.000")
     *  - moment("2017-11-24T06:45:00.000")
     *  - moment("2017-11-24T09:45:00.000")
     *  - moment("2017-11-24T12:45:00.000")
     *  - moment("2017-11-24T15:45:00.000")
     *  - moment("2017-11-24T18:45:00.000")
     *  - moment("2017-11-24T21:45:00.000")
     *  - moment("2017-11-25T00:45:00.000")
     * Es coloca una execució del día després per si arriba una petició a les 22:00, per exemple.
     */
    calcularLlistatActualitzacions(inici, periode, marge, ara) {
        // Avui i demà
        const avui = ara.clone().hour(0).minute(0).second(0).millisecond(0);
        const dema = avui.clone().add(1,  'days');

        // Càlcul d'inici, periode i marge
        const iniciAsMoment = this.obtenirMomentAPartirDHoraIMinut(avui, inici);
        const periodeAsDuration = this.obtenirDuracioAPartirDHoraIMinut(periode);
        const margeAsDuration = this.obtenirDuracioAPartirDHoraIMinut(marge);

        // Primera hora/minut d'actualització del dia
        let momentDExecucio = iniciAsMoment.clone().add(margeAsDuration);

        // Afegim totes les franges d'avui
        let llistatActualitzacions = [];
        while (momentDExecucio < dema) {
            llistatActualitzacions.push(momentDExecucio.clone());
            momentDExecucio = momentDExecucio.add(periodeAsDuration);
        }

        // Afegim la primera franja del dia de demà
        llistatActualitzacions.push(momentDExecucio.clone());

        return llistatActualitzacions;
    }

    /**
     * S'obté una llista d'actualitzacions com a l'exemple anterior i retorna quina és la hora següent
     * Per exemple, si el moment del dia és 24/11/2017 a les 12:34 retornarà, segons el llistat anterior,
     * un objecte moment amb "2017-11-24T12:45:00.000"
     */
    calcularSeguentActualitzacio(llistatActualitzacions, momentDelDia) {
        return llistatActualitzacions.find( (data) => {
            return momentDelDia < data;
        });
    }

    refrescaImatge(milisegons) {
        // Actualitzem l'estat amb la següent actualització. Provoca un render.
        const { seguentActualitzacio } = this.state;
        const novaSeguentActualitzacio = seguentActualitzacio.clone().add(milisegons);
        this.setState( { estaCarregantImatge: true, seguentActualitzacio: novaSeguentActualitzacio});

        // Netejem l'interval i el tornem a definir. Serveix principalment perquè la primera execució sempre serà més curta.
        clearInterval(this.refrescaImatgeInterval);
        this.refrescaImatgeInterval = setInterval(() => this.refrescaImatge(milisegons), milisegons);
    }

    componentDidMount() {
        const { inici, periode, marge, dataActual } = this.props;
        if (periode === '00:00') return;

        // Calculem la pròxima actualització
        const ara = convertirTextAMomentUTC(dataActual);
        const llistatActualitzacions = this.calcularLlistatActualitzacions(inici, periode, marge, ara);
        const seguentActualitzacio = this.calcularSeguentActualitzacio(llistatActualitzacions, ara);
        this.setState( { estaCarregantImatge: true, seguentActualitzacio } );

        // Definim el setInterval de la primera actualització
        const milisegonsPerALaPrimeraActualitzacio = seguentActualitzacio.diff(ara, 'milliseconds');
        const milisegonsPerALesSeguentsActualitzacions = this.obtenirDuracioAPartirDHoraIMinut(periode);
        this.refrescaImatgeInterval = setInterval(() => this.refrescaImatge(milisegonsPerALesSeguentsActualitzacions), milisegonsPerALaPrimeraActualitzacio);
    }

    componentWillUnmount() {
        clearInterval(this.refrescaImatgeInterval);
    }

    establirImatgeCarregada(seguentActualitzacio) {
        this.setState( { estaCarregantImatge: false, seguentActualitzacio } );
    }

    render() {
        // Al src de la imatge se li passa un paràmetre per tal de forçar que es recarregui i no l'agafi de la caché
        const { seguentActualitzacio, estaCarregantImatge } = this.state;
        const { alt, className, src, periode } = this.props;

        if (periode === '00:00') {
            return <div>El periode ha de ser superior a 0 minuts</div>;
        }

        return (
            <Spin
                spinning={estaCarregantImatge}
                delay={RETARD_MILISEGONS_APARICIO_SPINNER}
            >
                <img
                    alt={alt}
                    className={className}
                    src={src + '?seguentActualitzacio=' + seguentActualitzacio }
                    onLoad={ () => this.establirImatgeCarregada(seguentActualitzacio)}
                />
            </Spin>
        );
    }
}

ImatgeAutorrecarregable.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
    inici: PropTypes.string.isRequired,
    periode: PropTypes.string.isRequired,
    marge: PropTypes.string,
    dataActual: PropTypes.string
};

export default ImatgeAutorrecarregable;



// WEBPACK FOOTER //
// ./src/components/commons/imatgeAutorecarregable.js